import store from '@/store/index'
import apiConfig from '@/api/api'

const { api } = apiConfig()

const merchantDocuments = {
  namespaced: true,

  state: () => ({
    loading: false,
    merchantDocuments: null
  }),

  getters: {
    _loading: state => state.loading,
    _merchantDocuments: state => state.merchantDocuments
  },

  mutations: {
    LOADING (state, value) {
      state.loading = value
    },
    MERCHANT_DOCUMENTS (state, documents) {
      state.merchantDocuments = documents
    }
  },

  actions: {
    GetMerchantDocuments ({ rootState, dispatch }, config) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get(`/MerchantDocument/GetMerchantDocument?MerchantId=${config.id}`, config.config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(documents => {
            // rootState.loading = false
            resolve(documents)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    // ------------APPROVE/DISAPPROVE DOCUMENTS-----------------
    ApproveMerchantMeansofIdentificationDocument ({ rootState, dispatch }, config) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get(`/MerchantDocument/ApproveMerchantPrincipalMemberMeansofIdentificationDocument?MerchantId=${config.id}`, config.config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 500)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    DisapproveMerchantMeansofIdentificationDocument ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.delete(`/MerchantDocument/DisapproveMerchantPrincipalMemberMeansofIdentificationDocument?MerchantId=${payload.id}&Comment=${payload.comment}`, payload.config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(disapprovalData => {
            setTimeout(() => {
              rootState.loading = false
              resolve(disapprovalData)
            }, 500)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    ApproveMerchantCertificateofIncoporationDocument ({ rootState, dispatch }, config) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get(`/MerchantDocument/ApproveMerchantCertificateofIncoporationDocument?MerchantId=${config.id}`, config.config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 500)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    DisapproveMerchantCertificateofIncoporationDocument ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.delete(`/MerchantDocument/DisapproveMerchantCertificateofIncoporationDocument?MerchantId=${payload.id}&Comment=${payload.comment}`, payload.config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(disapprovalData => {
            setTimeout(() => {
              rootState.loading = false
              resolve(disapprovalData)
            }, 500)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    ApproveMerchantCompanyMemorandumDocument ({ rootState, dispatch }, config) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get(`/MerchantDocument/ApproveMerchantCompanyMemorandumDocument?MerchantId=${config.id}`, config.config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 500)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    DisapproveMerchantCompanyMemorandumDocument ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.delete(`/MerchantDocument/DisapproveMerchantCompanyMemorandumDocument?MerchantId=${payload.id}&Comment=${payload.comment}`, payload.config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(disapprovalData => {
            setTimeout(() => {
              rootState.loading = false
              resolve(disapprovalData)
            }, 500)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    ApproveMerchantFormCAC7Document ({ rootState, dispatch }, config) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get(`/MerchantDocument/ApproveMerchantFormCAC7Document?MerchantId=${config.id}`, config.config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 500)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    DisapproveMerchantFormCAC7Document ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.delete(`/MerchantDocument/DisapproveMerchantFormCAC7Document?MerchantId=${payload.id}&Comment=${payload.comment}`, payload.config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(disapprovalData => {
            setTimeout(() => {
              rootState.loading = false
              resolve(disapprovalData)
            }, 500)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    ApproveMerchantCompanyAddressUtilityBillDocument ({ rootState, dispatch }, config) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get(`/MerchantDocument/ApproveMerchantCompanyAddressUtilityBillDocument?MerchantId=${config.id}`, config.config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 500)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    DisapproveMerchantCompanyAddressUtilityBillDocument ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.delete(`/MerchantDocument/DisapproveMerchantCompanyAddressUtilityBillDocument?MerchantId=${payload.id}&Comment=${payload.comment}`, payload.config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(disapprovalData => {
            setTimeout(() => {
              rootState.loading = false
              resolve(disapprovalData)
            }, 500)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    ApproveMerchantGovtAgencyOperationalLicenceDocument ({ rootState, dispatch }, config) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get(`/MerchantDocument/ApproveMerchantGovtAgencyOperationalLicenceDocument?MerchantId=${config.id}`, config.config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 500)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    DisapproveMerchantGovtAgencyOperationalLicenceDocument ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.delete(`/MerchantDocument/DisapproveMerchantGovtAgencyOperationalLicenceDocument?MerchantId=${payload.id}&Comment=${payload.comment}`, payload.config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(disapprovalData => {
            setTimeout(() => {
              rootState.loading = false
              resolve(disapprovalData)
            }, 500)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    // ------------UPLOAD DOCUMENTS-----------------
    UploadMerchantMeansofIdentificationDocument ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post('/MerchantDocument/UploadMerchantPrincipalMemberMeansofIdentificationDocument', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    UploadMerchantCertificateofIncoporationDocument ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post('/MerchantDocument/UploadMerchantCertificateofIncoporationDocument', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    UploadMerchantCompanyMemorandumDocument ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post('/MerchantDocument/UploadMerchantCompanyMemorandumDocument', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    UploadMerchantFormCAC7Document ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post('/MerchantDocument/UploadMerchantFormCAC7Document', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    UploadMerchantCompanyAddressUtilityBillDocument ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post('/MerchantDocument/UploadMerchantCompanyAddressUtilityBillDocument', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    UploadMerchantGovtAgencyOperationalLicenceDocument ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post('/MerchantDocument/UploadMerchantGovtAgencyOperationalLicenceDocument', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    // -----------DOWNLOAD DOCUMENTS----------------

    DownloadDocument ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootState.loading = true

        api({
          url: `/MerchantDocument/${payload.action}?MerchantId=${payload.id}`,
          method: 'GET',
          responseType: 'blob', // file type to be returned
          headers: payload.config.headers
        })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    }
  }
}

export default merchantDocuments
